module.exports = __webpack_public_path__ + "static/media/Canoe - No Lead Vocals.074b9e78.jpg";